import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogMaterials } from "../../repositories/CatalogMaterialRepository";
import { useCatalogMaterialContext } from "./CatalogMaterialContext";
import { TableMaterial } from "./components/TableMaterial";

type Props = {};
export const CatalogMaterialPage = (props: Props) => {
	const { state, actions } = useCatalogMaterialContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogMaterialFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogMaterials();
		if (resp.ok) {
			actions.setMaterials(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};
	useEffect(() => {
		getCatalogMaterialFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.materials) {
		return (
			<>
				<HelmetDexteel title="Materials - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableMaterial
								isLoading={isLoading}
								getCatalogMaterialFromAPI={getCatalogMaterialFromAPI}
							/>
						</Paper>
					</Grid>
					<ErrorModal error={error} onHide={() => setError("")} />
				</Grid>
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
